module.exports = __webpack_public_path__ + "img/Neuralike-Logo-Horizontal.21504c8d.svg";